/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {BulkActionEntity, CTCEntity} from '@ion/core/src/types/entities';
import {SelectAllSearch} from '../search/types';

export enum DialogType {
  BULK_ACTION_DIALOG = 'BULK_ACTION_DIALOG'
};

export interface SelectedGridDataProps extends SelectAllSearch {
  onRefresh?: Function;
  selectedChips?: CTCEntity[];
  title?: string;
  entity?: BulkActionEntity;
  overrideBulkEntityType?: BulkActionEntity;
  defaultIdentifier?: string;
  isProvisioning?: boolean;
  customSearch?: boolean;
  showFileOption?: boolean;
  excludedDevices: CTCEntity[];
}
